import React from 'react';
import { Container } from 'react-bootstrap';

const HeroImg = () => {
  return (
    <div id="home">
      <div className="hero-main"></div>
      <Container>
        <div className="bg-text">
          <h1>Building Scalable Systems & Modern Web Applications</h1>
          <p className="mt-2 text-light">Full-Stack Developer | MERN & Java Spring Boot</p>
        </div>
      </Container>
    </div>
  );
};

export default HeroImg;